export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const SET_ONBOARDING_OVERLAY = 'SET_ONBOARDING_OVERLAY';
export const SET_HAS_CHARGEBEE_CUSTOMER = 'SET_HAS_CHARGEBEE_CUSTOMER';
